import { IconProps } from '@phosphor-icons/react';
import {
    Car,
    ForkKnife,
    Globe,
    GraduationCap,
    Heartbeat,
    ShoppingBag,
    Sparkle,
    Storefront,
    Briefcase,
    Wrench,
    Ticket
} from '@phosphor-icons/react';

export interface Industry {
  id: string;
  label: string;
  desc: string;
  icon: React.ComponentType<IconProps>;
}

export const INDUSTRIES: Industry[] = [
    {
        id: 'ecommerce',
        label: 'E-commerce',
        desc: 'From first click to loyal customer',
        icon: ShoppingBag
    },
    {
        id: 'retail',
        label: 'Retail',
        desc: 'Unify your online and in-store operations',
        icon: Storefront
    },
    {
        id: 'restaurants',
        label: 'Restaurants',
        desc: 'From table turnover to delivery ROAS',
        icon: ForkKnife
    },
    {
        id: 'fitness',
        label: 'Fitness',
        desc: 'From memberships to class performance',
        icon: Heartbeat
    },
    {
        id: 'beauty',
        label: 'Beauty',
        desc: 'From appointment bookings to product sales',
        icon: Sparkle
    },
    {
        id: 'agencies',
        label: 'Agencies',
        desc: 'From client acquisition to project profitability',
        icon: Briefcase
    },
    {
        id: 'home-services',
        label: 'Home Services',
        desc: 'From job bookings to crew productivity',
        icon: Wrench
    },
    {
        id: 'automotive',
        label: 'Automotive',
        desc: 'From sales floor to service bay performance',
        icon: Car
    },
    {
        id: 'events',
        label: 'Events',
        desc: 'From ticket sales to venue optimization',
        icon: Ticket
    },
    {
        id: 'education',
        label: 'Education',
        desc: 'From course creation to student success',
        icon: GraduationCap
    },
    {
        id: 'other',
        label: 'Other',
        desc: 'Tell us about your industry',
        icon: Globe
    },
];
